import React, { type ReactNode } from 'react';

import Icons from 'assets/icons';

export interface Statuses {
  ACTIVE?: string;
  EXPIRED?: string;
  HIDDEN?: string;
  ARCHIVED?: string;
  MOCKED?: string;
  [key: string]: string | undefined;
}

export const getStatusLabel = (
  value: string,
  statuses: Statuses
): ReactNode => {
  const defaultIconProps = {
    width: '12px',
    height: '100%',
    className: 'pt-px',
  };

  const commonStyles =
    'flex items-center font-xs font-semibold py-1.5 px-2 rounded-md w-fit';

  const commonValueStyles = 'pl-1 lowercase first-letter:uppercase';

  switch (value) {
    case statuses.ACTIVE:
      return (
        <div className={`${commonStyles} text-lime-900 bg-success-100`}>
          <Icons.Active aria-label="active-status" {...defaultIconProps} />
          <span className={commonValueStyles}>{value}</span>
        </div>
      );
    case statuses.EXPIRED:
      return (
        <div className={`${commonStyles} text-critical-700 bg-critical-100`}>
          <Icons.Expired aria-label="expired-status" {...defaultIconProps} />
          <span className={commonValueStyles}>{value}</span>
        </div>
      );
    case statuses.HIDDEN:
      return (
        <div className={`${commonStyles} text-amber-700 bg-amber-100`}>
          <Icons.Hidden aria-label="hidden-status" {...defaultIconProps} />
          <span className={commonValueStyles}>{value}</span>
        </div>
      );
    case statuses.ARCHIVED:
      return (
        <div className={`${commonStyles} text-critical-700 bg-critical-100`}>
          <Icons.Archived aria-label="archived-status" {...defaultIconProps} />
          <span className={commonValueStyles}>{value}</span>
        </div>
      );
    case statuses.MOCKED:
      return (
        <div className={`${commonStyles} text-navy-800 bg-sky-100`}>
          <Icons.Expired aria-label="mocked-status" {...defaultIconProps} />
          <span className={commonValueStyles}>{value}</span>
        </div>
      );
    default:
      return (
        <div className={`${commonStyles} text-amber-700 bg-amber-100`}>
          <Icons.Warning aria-label="expiring-status" {...defaultIconProps} />
          <span className={commonValueStyles}>{value}</span>
        </div>
      );
  }
};
